import React, { useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import SafariBookingForm from '../SafariBookingForm/SafariBookingForm';
import './SafariSection.css';

const SafariSection = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  return (
    <section className="safari-section">
      <Container>
        <h2 className="section-title">Safari Booking</h2>
        
        <div className="safari-content">
          <div className="intro-text">
            <p>Looking to experience the thrill of the jungle? Corbett Aura makes it effortless for you to book exclusive Jeep or Canter Safari tours in the heart of Jim Corbett National Park. We offer seamless safari booking services across the park's top zones — Bijrani, Jhirna, Dhikala, Dhela, Garjia, and Durgadevi.</p>
            
            <p>All safari allocations are managed by forest department officials under government regulations to ensure fair and safe wildlife exploration. While we do not influence the selection of zones, guides, or drivers, rest assured — every zone offers rich wildlife, lush landscapes, and the chance to spot the majestic tiger.</p>
            
            <p>With Corbett Aura, your safari isn't just a booking — it's a fully customized adventure, designed to bring you closer to nature like never before. 🐅✨<br/>
            Let the forest call you — we'll take care of the rest.</p>
          </div>

          <div className="booking-procedure">
            <h3>Advance Booking Procedure</h3>
            <p>For booking request please provide us the following details:</p>
            <ul>
              <li>The full name, age, and sex of each visitor as printed same on the identity cards to be provided along with the confirmatory amount</li>
              <li>Preferred traveling date & Safari timing (Morning/Afternoon)</li>
              <li>Specific ID card number of your (Pan Card, Aadhaar No., Driving license No, etc.)</li>
              <li>Safari Entry fee paid in advance</li>
              <li>Jeep Safari & Canter Safari amounts are non-refundable</li>
              <li>Please carry the same ID card submitted during the online booking</li>
              <li>Please intimate us 45 days in advance (for Indian nationals)</li>
              <li>Foreign nationals can ask for booking 90 days in advance</li>
              <li>Passport details are mandatory for making reservations for foreign tourists</li>
              <li>Safari permit is issued on a first come first serve basis (subject to availability)</li>
            </ul>
          </div>

          <div className="important-info">
            <h3>Jim Corbett Safari Important information</h3>
            <ul>
              <li>Visitors are required to obtain entry permits that are being issued (by producing above mentioned documents)</li>
              <li>It should be noted that the entry permit to the Corbett National Park is provisional and can be changed or cancelled without any prior intimation</li>
              <li>The order of the Corbett Tiger Reserve Director will be final in this regard; we are governed by the rules made under the guidelines</li>
              <li>Entry permit belonging to you is not transferrable</li>
              <li>Only officially registered guides can join your excursions, please do not try to change the guide or naturalist</li>
              <li>Entry to the National Park is strictly prohibited after sunset</li>
              <li>Day visit to Dhikala Tourism Zone is not permitted except for the tourists staying inside the forest lodges</li>
              <li>While doing jeep safari do not get down from the vehicle, it is strictly not allowed</li>
              <li>Avoid carrying pets while you are on a holiday tour as no pets can be taken inside the CTR</li>
              <li>All visitors to the Corbett Tiger Reserve abide by the rules and regulations of the wildlife protection act. So please co-operate</li>
            </ul>
          </div>

          <div className="terms-conditions">
            <h3>Terms & Conditions for Online Jeep Safari Booking at Corbett National Park</h3>
            <ul>
              <li>A safari permit allows entry to a maximum of 6 individuals, inclusive of 2 children under the age of 12. Above 12 years considered as an adult</li>
              <li>Only authorized guides and gypsies are permitted inside the Corbett Tiger Reserve (CTR)</li>
              <li>Dhikala does not offer day safari permits. To enjoy a safari, please ensure to book either a Canter ride or a night stay</li>
              <li>The Canter is not a gypsy safari, but rather a 16-seater bus designed to provide a shared safari experience</li>
              <li>Canter allows a maximum of 4 individuals booking at once</li>
              <li>Seats must be purchased individually and children under 12 years are not allocated seats under the standard permit. To book a seat for them, a separate ticket must be purchased</li>
              <li>In the event of a delayed arrival, the Canter will not wait, and Canter permits cannot be adjusted or rescheduled</li>
              <li>Safari time changes according to season</li>
              <li>Jeep and Canter safari at Corbett is conducted only in two shifts – Morning and Evening daily</li>
              <li>Morning safari is conducted from 06:30 AM to 09:30 AM and afternoon safari time is from 02:30 PM to 05:30 PM</li>
              <li>Visitors are required to send their passport-size photograph needed for permit registration</li>
              <li>The number of visitors going on safari vehicles should not exceed the limit as they will be stopped at the entry gate</li>
              <li>The tourists are held responsible for their own luggage during the safari, no safari driver or guide is liable for the same</li>
              <li>Please read all the instructions before you plunge into the enthralling Jeep safari at Corbett National Park</li>
            </ul>
            <p className="note"><strong>Note:</strong> We are merely acting as a travel agent in booking your safari at the national park and will not be responsible for any accident, injury, theft, and death during the safari excursion.</p>
          </div>

          <div className="booking-action">
            <div className="pricing-info" style={{
              textAlign: 'center',
              marginBottom: '20px',
              fontSize: '1.2rem',
              color: '#D4AF37'
            }}>

            </div>
            <Button 
              onClick={() => setShowBookingForm(true)}
              style={{
                backgroundColor: '#D4AF37',
                border: 'none',
                padding: '12px 30px',
                fontSize: '1.1rem',
                marginTop: '10px'
              }}
            >
              Book Safari Now
            </Button>
          </div>
        </div>
      </Container>

      <Modal 
        show={showBookingForm} 
        onHide={() => setShowBookingForm(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Book Your Safari
            <span style={{ 
              marginLeft: '15px',
              fontSize: '0.9rem',
              color: '#666',
              fontWeight: 'normal'
            }}>
              (Starting from ₹7300)
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SafariBookingForm />
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default SafariSection;
